import { render, staticRenderFns } from "./userTest.vue?vue&type=template&id=6788c9ee&scoped=true&"
import script from "./userTest.vue?vue&type=script&lang=js&"
export * from "./userTest.vue?vue&type=script&lang=js&"
import style0 from "./userTest.vue?vue&type=style&index=0&id=6788c9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788c9ee",
  null
  
)

export default component.exports